<template>
    <section class="cabinet__wrap">
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-100">
                <h2 class="cabinet__title">Информация о микрокредите</h2>
            </div>
        </div>
        <div class="cabinet__row">
            <div class="cabinet__column cabinet__column--width-100">
                <ul class="current-loan">
                    <li class="current-loan__row">
                        <div class="current-loan__column">Номер договора</div>
                        <div class="current-loan__column">{{currentLoan.documentNumber}}</div>
                    </li>
                    <li class="current-loan__row">
                        <div class="current-loan__column">Статус</div>
                        <div class="current-loan__column">{{currentLoan.creditStatus}}</div>
                    </li>
                    <li class="current-loan__row">
                        <div class="current-loan__column">Сумма микрокредита</div>
                        <div class="current-loan__column">{{currentLoan.amount | numberFormat}} ₸</div>
                    </li>
                    <li class="current-loan__row">
                        <div class="current-loan__column">На срок</div>
                        <div class="current-loan__column">{{formatTerm}}</div>
                    </li>
                    <li class="current-loan__row" v-if="currentLoan.RepaidForToday">
                        <div class="current-loan__column">Погашено на сегодня</div>
                        <div class="current-loan__column">{{currentLoan.RepaidForToday | ceil | numberFormat}} ₸</div>
                    </li>
                    <li class="current-loan__row" v-if="currentLoan.DebtForToday">
                        <div class="current-loan__column">Задолженость на сегодня</div>
                        <div class="current-loan__column">{{currentLoan.DebtForToday | ceil | numberFormat}} ₸</div>
                    </li>
                    <li class="current-loan__row" v-if="currentLoan.MonthlyPayment">
                        <div class="current-loan__column">Ежемесячный платеж</div>
                        <div class="current-loan__column">{{currentLoan.MonthlyPayment | ceil | numberFormat }} ₸</div>
                    </li>

                </ul>
            </div>
        </div>
    </section>
</template>

<script>
    import Helpers from "@/modules/Helpers";

    export default {
        name: 'currentLoan',
        metaInfo: {
            title: 'Информация о текущем займе'
        },
        data(){
            return {

            }
        },
        methods: {},
        computed: {
            currentLoan: function () {
                return this.$store.getters['current/getCurrentLoan']
            },
            formatTerm: function () {
                return this.currentLoan.term +' '+ Helpers.declension(['месяц','месяца','месяцев'], this.currentLoan.term);
            }
        },
        mounted(){
            this.$store.dispatch('current/getCurrentCredit');
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .cabinet__wrap{}
    .cabinet__title{
        text-align: left;
        font-size: 18px;
        color: $purple-site;
        font-weight: normal;
        font-family: $RobotoRegular;

    }
    .current-loan{
        &__row{
            max-width: 100%;
            &:nth-child(even){
                background-color: #F0F0F0;
            }
            &:nth-child(odd){
                background-color: rgba(240,240,240,0.5);
            }
            &:not(:first-child){
                margin-top: 5px;
            }
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 10px 15px;

        }
        &__column{

            &:first-child{
                text-align: left;
            }
            &:last-child{
                text-align: right;
                min-width: 85px;
                display: block;
            }
        }
    }
</style>